module.exports = __webpack_public_path__ + "static/02-571bb8b90e6c138169ad4abfd9739e75.jpg";